import * as React from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import {Switch} from '@mui/material';
import FormGroup from '@mui/material/FormGroup';

import {useFormContext} from 'react-hook-form';

import { Controller } from "react-hook-form"

const FormSwitch = ({name,label,required,rules = {},...props}) => {

    const {control} = useFormContext();

    const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
    rules = { ...requiredDefaultRule, ...rules };

    return (

        <Controller
            render={({field: {onChange, value }}) =>(
                <FormGroup>
                    <FormControlLabel control={<Switch checked={value} onChange={onChange} color="secondary" {...props} />} label={label} />
                </FormGroup>
            )}
            name={name}
            control={control}
            rules={rules}
        />
    );
};
export default FormSwitch;
